import global from "../utility/global";

class anioMock {
    values = global.getAnios();
}
export default new anioMock();